import { isCommunityAdmin } from "@/react/helpers/communityMemberHelpers";
import { useChecklist } from "@/react/hooks/useChecklist";
import { usePunditUserContext } from "@circle-react/contexts";

export const useShowOnboarding = () => {
  const { currentCommunityMember } = usePunditUserContext();
  const { isChecklistAvailable } = useChecklist();
  const isAdmin = isCommunityAdmin(currentCommunityMember);

  return {
    showOnboarding: isChecklistAvailable && isAdmin,
  };
};
